export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";